import { lazy, Suspense } from "react"
import { Outlet, Navigate } from "react-router-dom"

import { CONFIG } from "src/config-global"
import { DashboardLayout } from "src/layouts/dashboard"
import { LoadingScreen } from "src/common/loading-screen"
import { AuthGuard } from "src/auth/guard"
import { paths } from "../paths"

// ----------------------------------------------------------------------

const JobPostingFormPage = lazy(() => import("@/src/features/jobPosting/jobPostingForm/jobPostingFormPage"))

// ----------------------------------------------------------------------

const LayoutContent = () => {
    const layout = (
        <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
                <Outlet />
            </Suspense>
        </DashboardLayout>
    )
    return CONFIG.auth.skip ? <>{layout}</> : <AuthGuard>{layout}</AuthGuard>
}

export const postJobRoutes = [
    {
        path: "post-job",
        element: LayoutContent(),
        children: [
            { index: true, element: <Navigate to={paths.postJob.jobDescription} replace /> },
            { path: "job-description", element: <JobPostingFormPage /> },
            { path: "job-details", element: <JobPostingFormPage /> },
            { path: "interview-setup", element: <JobPostingFormPage /> },
            { path: "review-publish", element: <JobPostingFormPage /> },
        ],
    },
]

